import React, { useEffect, useState } from 'react';
import Stomp from "stompjs";
//import { NotificationManager } from 'react-notifications';

let url =  "wss://b-120f4817-28b4-42b1-8484-d17d4baa1caa-1.mq.mx-central-1.amazonaws.com:61619";
const url1 =  "wss://b-120f4817-28b4-42b1-8484-d17d4baa1caa-1.mq.mx-central-1.amazonaws.com:61619";
const url2 =  "wss://b-120f4817-28b4-42b1-8484-d17d4baa1caa-2.mq.mx-central-1.amazonaws.com:61619";
const user = "WEBSOCKET";
const pass = "w3bs0k3t2024";
let client = Stomp.client(url);
let postOrigin = false;

const MonitoreoMensajeria = ({
    topic,
    mensaje,
    elementosT,
    storeFunction,
    updateT,
    metodo,
    stor
}) => {

const [mensajeEntrante, setMensajeEntrante] = useState(null);
 
useEffect(() => {
    //console.log(topic);
    if(topic.length){
      console.log("conectar al websocket: ");
      conectar();
    }    
}, [topic]);

const conectar = () => {        
    client = Stomp.client(url);
    client.heartbeat = {
        incoming: 20000,
        outgoing: 20000,
    };
    client.debug = () => {};
    client.reconnect_delay = 5000;
    client.connect(
        user,
        pass,
        (frame) => {
            //console.log(topic);
          //Conect callback       
          if (topic && topic.length) {
            for (let t of topic) {
                //console.log(topic);
              client.subscribe(t, (message) => { 
                //let actualizar= udate;        
                if (message.body.includes("{")) {  
                  //actualizar(message.body); 
                  //console.log(message.body); 
                  setMensajeEntrante(JSON.parse(message.body));
                }              
              });
            }
          }
        },
        (err) => {               
          url = (url === url1) ? url2 : url1;
          //error useCallback
          console.log(err);
          if (typeof err === "string" && err.toUpperCase().includes("LOST CONNECTION")) {
            setTimeout(() => {
              conectar();
            }, 5000);
            //alert(err);
          }        
        }
    );
}

useEffect(() => {
    if(mensajeEntrante){
      udate(mensajeEntrante);
    }    
}, [mensajeEntrante]);

useEffect(() => {
    if(metodo !== "get"  && stor.updateStatusMensaje_Object && mensaje.data){
      sendMessage("clientes-" + mensaje.data.idPlataforma.id + mensaje.data.corredor.id , mensaje);
    }
}, [metodo, mensaje]);


const udate = (mensaje) => {
    //console.log(mensaje.vista);        
    if(mensaje.vista == "terrestreMovimientos"){
        /*NotificationManager.info(mensaje.mensaje,
            mensaje.accion === "put" ?  "Modificación":
            mensaje.accion === "post" ? "Nuevo":
            mensaje.accion === "delete" ? "Finalizar Movimiento":"Acción",200);*/
        let movimientos=  elementosT;
        if (mensaje.accion !== "post"){
            if(movimientos){    
              movimientos.map((elemento, index) =>{
               switch (mensaje.accion) {
                 case "put":
                   if(elemento["id"] === mensaje.data.id){
                     movimientos[index]= mensaje.data;
                   }
                   break;
                 case "delete":
                   if(elemento["id"] == mensaje.data.id){
                     movimientos.splice(index, 1) }
                   break;
                 default:  break;
               }
             });
           }
        }
        if (mensaje.accion === "post" && postOrigin === false){
             movimientos.push(mensaje.data); 
        }else{ 
            postOrigin= false; 
        }
        if(movimientos){
            //stor.movimientos_terrestres_update([...movimientos]);
            if( updateT !== "" ){ updateT([...movimientos]); }
        }            
    }
  }

  const sendMessage = (topic, msg) => {   
    stor.updateStatusMensaje(false);  
    postOrigin= true;
    if(msg.vista == "terrestreMovimientos"){           
        client.send(topic, {}, JSON.stringify(msg));
    }         
  };

  return (
    <>      
    </>
  )
}

export default MonitoreoMensajeria;
